var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGeneratorUse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 22,
  viewBox: "0 0 16 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.9 5.7v14.1h12.3V5.7zM16 3.9v17.7H.1V3.9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 5.7H2.7V.4h1.8zM13.3 5.7h-1.8V.4h1.8zM4.5 13.6 8.7 8l1.4 1.1L8 11.9h3.5l-4.2 5.6-1.4-1L8 13.6z"
})));
export default SvgGeneratorUse;